import { VB_NUMBER, VB_ZIP_CODE, VM_NUMBER } from 'modules/Inquiry/Form/formFields';

// The order of these labels is relevant for inquiry details page
export const additionalFieldsTranslations: { [key: string]: string } = {
  [VB_NUMBER]: `pages.companyDetails.sections.contactPerson.fields.companyDetailsVbNumber.caption`,
  [VM_NUMBER]: `pages.companyDetails.sections.contactPerson.fields.companyDetailsVmNumber.caption`,
  [VB_ZIP_CODE]: `components.contactSidebar.callbackRequest.fields.postalCode.caption`,
};
